const rail = {
  rails: "रेल", // translated 
  senior: "वरिष्ठ", // translated 
  seniors: "वरिष्ठ", // translated 
  youths: "युवाओं", // translated 
  yearOld: "साल", // translated 
  yearsOld: "वर्षों पुराना", // translated 
};


export default rail;
